import Notification from './styled';

export default Notification;
